import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <section data-testid="not-found-page" className="mx-auto flex max-w-xl flex-col items-start px-6 py-32 animate-in fade-in slide-in-from-bottom-3 duration-500">
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-50 text-[#064E3B]"><Compass className="h-7 w-7" /></span>
      <p className="mt-6 font-mono text-sm font-bold text-[#E11D48]">404</p>
      <h1 data-testid="not-found-title" className="mt-1 text-4xl font-extrabold text-slate-900 sm:text-5xl">{t("nf_title")}</h1>
      <p className="mt-3 text-base text-slate-500">{t("nf_sub")}</p>
      <Link to="/" data-testid="not-found-home-link" className="mt-8 rounded-full bg-[#064E3B] px-6 py-3 font-bold text-white transition-transform hover:-translate-y-0.5">{t("nf_home")}</Link>
    </section>
  );
}
